<template>
  <div class="modal">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title">Postar na galeria</div>
        <div class="subTitle">Leia as regras antes de postar!</div>
        <div class="close" @click="emits('close')"><i class="fa-solid fa-xmark"></i></div>
      </div>
      <div class="content">
        <form @submit="setArt">
          <input type="text" name="title" placeholder="Título" v-model="title" required>
          <input type="text" name="description" placeholder="Descrição" v-model="description" required>
          <input type="file" name="img" class="file" accept="image/*" id="file" ref="fileInput" required>
          <button :disabled="loading">{{ loading ? 'Enviando...' : 'Confirmar' }}</button>
        </form>
      </div>
    </div>
  </div>
  <Alerta v-if="textalert !== ''" :text="textalert" />
</template>

<script setup>
import Alerta from '@/components/usefulness/alert.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/stores/index.js'
import { nowMysql } from '@/services/api.js'

const emits = defineEmits(['close'])
const router = useRouter()
const store = useStore()

const title = ref('')
const description = ref('')
const fileInput = ref()
const textalert = ref('')
const loading = ref(false)

function slugify(str) {
  return String(str).toLowerCase()
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .substring(0, 40)
}

async function setArt(e) {
  e.preventDefault()
  if (loading.value) return
  if (!store.logged) {
    textalert.value = 'Faça login para postar'
    setTimeout(() => textalert.value = '', 3000)
    return
  }
  const file = fileInput.value?.files?.[0]
  if (!file) {
    textalert.value = 'Selecione uma imagem'
    setTimeout(() => textalert.value = '', 3000)
    return
  }

  loading.value = true
  try {
    // 1. upload da imagem
    const fd = new FormData()
    fd.append('file', file)
    const upRes = await fetch('/api/upload/arts', { method: 'POST', credentials: 'include', body: fd })
    const upData = await upRes.json()
    if (!upRes.ok || !upData.success) {
      textalert.value = upData.message ?? 'Erro ao enviar imagem'
      setTimeout(() => textalert.value = '', 3500)
      loading.value = false
      return
    }

    // 2. cria registro da arte
    const slug = slugify(title.value) || ('arte-' + Date.now())
    const artRes = await fetch('/api/records/arts', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title:        title.value,
        description:  description.value,
        image:        upData.path,
        url:          slug,
        user_id:      store.initUser.id,
        is_published: true,
        published_at: nowMysql(),
      }),
    })
    const artData = await artRes.json()
    if (typeof artData === 'number') {
      textalert.value = 'Arte postada!'
      setTimeout(() => {
        emits('close')
        router.push({ path: `/arte/${artData}/${slug}` })
      }, 1000)
    } else {
      textalert.value = artData.message ?? 'Erro ao salvar arte'
      setTimeout(() => textalert.value = '', 3500)
    }
  } catch (err) {
    textalert.value = 'Erro ao enviar arte'
    setTimeout(() => textalert.value = '', 3500)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.content .file {
  background-color: var(--color1);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
</style>
